/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSupportBlockFragment} from '@amblique/contentful/app/contentful/fragments/support-block/base-support-block.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const SupportBlockFragment = gql`
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseSupportBlockFragment}

  fragment SupportBlockFragment on SupportBlock {
    ...BaseSupportBlockFragment

    actionsCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    actionsCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    image {
      ...BaseImageFragment
    }
  }
`;
